import { Flex } from '@chakra-ui/react';
import { Button } from '@mesh.ai/rabbit';
import { L3_PATHS } from 'Deer/constants/routes';
import { useHistory } from 'react-router-dom';

import { TextLabel } from 'uiToolkitV1/Typography';

import { useLaunchSurvey, useSurveyLastSavedTime } from './dataHook';

type SurveyCreationFooterProps = {
  surveyId: string;
  isReadOnly: boolean;
};

export const SurveyCreationFooter = ({ surveyId, isReadOnly }: SurveyCreationFooterProps) => {
  const history = useHistory();
  const { lastSavedTime } = useSurveyLastSavedTime();
  const { mutate: launchSurvey, isLoading: isLaunching } = useLaunchSurvey(surveyId);

  const handleCancel = () => {
    history.push(`${L3_PATHS.company.engagement.settings}?activeTabId=engagement_surveys`);
  };

  const handleLaunchSurvey = () => {
    launchSurvey();
  };

  return (
    <Flex
      py={3}
      px={4}
      justifyContent="space-between"
      alignItems="center"
      bg="surface.F5F7F9"
      borderTop="1px solid"
      borderColor="border.CFD7DF"
      borderBottomRadius="8px"
    >
      <Button variant="transparentOutline" onClick={handleCancel}>
        Cancel
      </Button>
      <Flex alignItems="center" gap={6}>
        {lastSavedTime && <TextLabel bold>Auto-saved, last saved at {lastSavedTime}</TextLabel>}
        <Button disabled={isReadOnly || isLaunching} onClick={handleLaunchSurvey}>
          {isLaunching ? 'Launching...' : 'Launch'}
        </Button>
      </Flex>
    </Flex>
  );
};
